<template>
  <v-container fluid class="pa-0">
    <v-row no-gutters>
      <v-col cols="12">
        <div class="ag-main">
          <div
            class="ag-container"
            v-if="!loadingStartMeeting && appId.length > 0"
            :style="
              $vuetify.breakpoint.name === 'xs'
                ? 'height: calc(100vh - 56px);'
                : 'height: calc(100vh - 64px);'
            "
          >
            <VideoCall
              :video-profile="videoProfile"
              :channel="channel"
              :transcode="transcode"
              :attendee-mode="attendeeMode"
              :base-mode="baseMode"
              :app-id="appId"
              :uid="uid"
              :log-id="logId"
              :user="user"
            >
            </VideoCall>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-overlay :value="loadingStartMeeting">
      <v-progress-circular indeterminate size="64" />
    </v-overlay>
  </v-container>
</template>

<script>
import meeting from '@/mixins/meeting';
import VideoCall from '@/components/VideoCall.vue';
export default {
  components: {
    VideoCall
  },
  mixins: [meeting],
  data() {
    return {
      appId: '',
      logId: '',
      channel: '',
      videoProfile: '480p_4',
      transcode: 'interop',
      attendeeMode: 'video',
      baseMode: 'avc',
      uid: undefined,
      user: {}
    };
  },
  async created() {
    const results = await this.startMeeting(this.$route.params.uid);
    this.appId = results.token;
    this.channel = results.channelName;
    this.user = results.receiver;
  }
};
</script>

<style scoped>
.ag-main {
  position: relative;
  overflow: hidden;
  max-width: 100vw;
}
.ag-container {
  min-height: 500px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 0.1);
}
</style>
